function singleSort (property) {
  return function (a,b) {
    let av = a[property] || ''
    let bv = b[property] || ''
    return av.localeCompare(bv, 'cz', {numeric: true})
  }
}

function multiSort () {
  let props = arguments
  return function (obj1, obj2) {
    let i = 0, result = 0, numberOfProperties = props.length;
    while(result === 0 && i < numberOfProperties) {
        result = singleSort(props[i])(obj1, obj2)
        i++
    }
    return result
  }
}

export default multiSort



// WEBPACK FOOTER //
// ./src/utils/arrayMultipleSort.js